import { Injectable } from '@angular/core';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { UserInfoStateStructure, LOGIN_INFO_REDUCER_NAME } from '@ptl/account-management';
import { PRODUCT_GROUPS } from 'src/app/angular-elements/plan-selection/enums/product-groups.enum';
import { PrePopulatedDataStateStructure } from 'src/app/angular-elements/shared/components/configs/interfaces/prePopulatedDataStateStructure.interface';
import { FormError } from 'src/app/angular-elements/shared/components/interfaces/form-error.interface';

@Injectable({
    providedIn: 'root'
})
export class EnrollmentSubmissionWHBService {

    productGroup = PRODUCT_GROUPS.WHOLE_HEALTH_BALANCE;
    productType = 'WHB';

    constructor(
        private reducerUtilityService: ReducerUtilityService,
    ) { }

    getWHBStateInfo(payloadState) {
        const prePopulatedDataState: PrePopulatedDataStateStructure = this.reducerUtilityService.getState('PrePopulateData');
        const loginInfoState: UserInfoStateStructure = this.reducerUtilityService.getReducerFromApplicationState(LOGIN_INFO_REDUCER_NAME);
        const prePopulateData: PrePopulatedDataStateStructure = this.reducerUtilityService.getState('PrePopulateData');

        payloadState.enrollment.productData.planName = 'Whole Health Balance';

        payloadState.enrollment.memberIdNumber = prePopulatedDataState.prepopulatedFields.memberIdNumber;
        payloadState.enrollment.mediGapMemberId = prePopulatedDataState.prepopulatedFields.memberIdNumber;
        payloadState.enrollment.agreementId = (
            (
                loginInfoState.memberInfo &&
                loginInfoState.memberInfo.agreementId
            ) ||
            (
                prePopulateData.prepopulatedFields &&
                prePopulateData.prepopulatedFields &&
                prePopulateData.prepopulatedFields.memberLookup &&
                prePopulateData.prepopulatedFields.memberLookup.AGREEMENTID
            )
        );
        payloadState.enrollment.enrollElection = 'true';

        delete payloadState['whbEligibility'];

    }

    validateMandatoryFields(payload: any, activeProductGroup: PRODUCT_GROUPS): FormError {
        const formErr: FormError = {
            valid: true,
            fieldName: ''
        };
        if (activeProductGroup === PRODUCT_GROUPS.WHOLE_HEALTH_BALANCE) {
            if (payload.enrollment) {
                if (!payload.enrollment.memberIdNumber) {
                    formErr.valid = false;
                    formErr.fieldName = 'Member ID Number';
                } else if (!payload.enrollment.agreementId) {
                    formErr.valid = false;
                    formErr.fieldName = 'Agreement ID Number';
                }
                if (payload.enrollment.productData) {
                    if (!payload.enrollment.productData.groupNo) {
                        formErr.valid = false;
                        formErr.fieldName = 'Old Group Number';
                    } else if (!payload.enrollment.productData.newGroupNo) {
                        formErr.valid = false;
                        formErr.fieldName = 'New Group Number';
                    }
                }
            } else {
                formErr.valid = false;
                formErr.fieldName = '';
            }
        }
        return formErr;
    }
}

